import React, { useEffect, useState } from "react";
import "./News.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchNewsRequest } from "../../../../../store/features/actions/opportunities/newsActions";
import { useParams } from "react-router-dom";
import * as FeatherIcon from "react-feather";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import GeneratingLoader from "../../../genericComponents/uiElements/GeneratingLoader";
import { displayFormattedDate } from "../../../../../services/commonService";
import PlainModal from "../../../../HtmlElements/PlainModal";


export default function News({ opportunityId }) {
  const dispatch = useDispatch();
  const { accountName } = useParams();
  const [status, setStatus] = useState("Processing...");
  const [result, setResult] = useState(null);
  const { newsData, newsLoading, error } = useSelector(
    (state) => state?.newsReducer
  );

  const { getTaskStatus } = useTaskStatus();
  const taskStatus = getTaskStatus(`opp_sidecard_news_${opportunityId}`);
  const [showDetailModal, setShowDetailModal] = useState("")

  const handleMore = (opportunity_description) => {
    setShowDetailModal(opportunity_description);
  };
  const handleClose = () => {
    setShowDetailModal("");
  };

  useEffect(() => {
    if (taskStatus=="completed") {
      if (opportunityId?.length > 0) {
        dispatch(fetchNewsRequest({ opportunityId }));
      }
    }
  }, [taskStatus])


  useEffect(() => {
    if (opportunityId?.length > 0) {
      dispatch(fetchNewsRequest({ opportunityId }));
    }
  }, [opportunityId]);

  useEffect(() => {
    if (newsData) {
      setResult(newsData);
      setStatus("Completed!");
    } else if (error) {
      setStatus("Error loading data");
    }
  }, [newsData, error]);

    if (taskStatus=="pending" && taskStatus!="failed") {  
      return(
      <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
        <GeneratingLoader/>
      </div>)
    }

  return (
    <div className="m-2">
      {showDetailModal &&
        <PlainModal
          title={showDetailModal?.title}
          text={showDetailModal?.snippet}
          handleClose={handleClose}
        />}
      {newsLoading == true || result === null ? (
        <>
          {[...Array(6)].map((_, index) => (
            <div className="news_wrapper w-100">
              <div className="news_block">
                <div className="news_emoji_block">
                  <div className="name_icon">
                    <div className="news_name_logo_block">
                      <p className="news_comp_name card-text placeholder-glow">
                        <span
                          class="placeholder col-md-3 mr-3"
                          style={{ width: "50px" }}
                        >
                          {" "}
                        </span>
                        <span
                          class="placeholder col-md-8 "
                          style={{ width: "300px" }}
                        >
                          {" "}
                        </span>
                      </p>
                    </div>

                    <div className="positive_block mt-2">
                      <p className="positive_text_2">
                        <span
                          class="placeholder col-md-8"
                          style={{ width: "80px" }}
                        >
                          {" "}
                        </span>
                      </p>
                    </div>
                  </div>

                  <div className="news_content">
                    <h5 className="nes_content_head">
                      <span
                        class="placeholder placeholder-sm w-100 col-md-8"
                      >
                        {" "}
                      </span>
                    </h5>
                    <p className="news_content_para pt-2">
                      <span
                        class="placeholder placeholder-xs w-100 col-md-8"
                      >
                        {" "}
                      </span>
                      <span
                        class="placeholder placeholder-xs w-75 col-md-8" >
                        {" "}
                      </span>

                      
                    </p>
                  </div>

                  <div className="news_bottom_block">
                    <div className="news_date_name_block">
                      <div className="news_name_subblock">
                        <p className="news_name">
                          <span
                            class="placeholder placeholder-sm col-md-8"
                            style={{ width: "100px" }}
                          >
                            {" "}
                          </span>
                        </p>
                      </div>
                      <div className="news_name_subblock">
                        <p className="news_name">
                          <span
                            class="placeholder placeholder-sm col-md-1"
                            style={{ width: "5px" }}
                          >
                            {" "}
                          </span>
                        </p>
                      </div>
                      <div className="news_name_subblock">
                        <p className="news_name">
                          <span
                            class="placeholder placeholder-sm col-md-8"
                            style={{ width: "70px" }}
                          >
                            {" "}
                          </span>
                        </p>
                      </div>
                    </div>
                    {/* <div className='news_share_block'>
                      <p className='news_share_text'>Share</p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : Object.keys(result).length === 0 ? (
        <div className="no-data-message">
          <NoDataComp
           message="Content is being generated"
           buttonText="Refresh"
           onButtonClick={() =>  dispatch(fetchNewsRequest({opportunityId}))}
        />

        </div>
      ) : (
        result?.map((news, index) => {
          return (
            <div className="news_wrapper">
              <div className="news_block">
                <div className="news_emoji_block">
                  <div className="name_icon">
                    <div className="news_name_logo_block" key={news?._id}>
                      {/* <img
                        src={`https://mnmks.com/subscribers/get_logo_image_path?company_code=${accountName}`}
                        className="news_comp_logo"
                      /> */}
                      <p className="news_comp_name">{news?.category}</p>
                    </div>
                    {news?.positive_negative === "Positive" ? (
                      <div className="positive_block">
                        <p className="positive_text">
                        <img src="/img/positive_frown.png" className="positive_icon"/>{news?.positive_negative}
                        </p>
                      </div>
                    ) : (
                      <div className="negative_block">
                        <p className="negative_text">
                        <img src="/img/negative_frown.png" className="negative_icon"/>
                          {news?.positive_negative}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="news_content">

                    {news?.news_link ? (
                      <a href={news?.news_link} className="nes_content_head" target="_blank">{news?.title}</a>
                    ): (
                      <span className="nes_content_head" style={{cursor: 'default'}} >{news?.title}</span>
                    )}

                    <p className="news_content_para pt-2">{news?.snippet}</p>
                    {
                      news?.snippet && (<p className='show_more pt-2' onClick={() => handleMore(news)}><i className="fa fa-ellipsis-h" aria-hidden="true"></i></p>)
                    }

                  </div>
                  <div className="news_bottom_block">
                    <div className="news_date_name_block">
                      <div className="news_name_subblock">
                        
                        {news?.news_link ? (
                          <p className="news_name"><a href={news?.news_link} target="_blank" style={{
                            color: '#64748b',
                            textDecoration: 'none'
                          }}>{news?.source}</a></p>
                        ): (
                          <p className="news_name">{news?.source}</p>
                        )}
                        
                      </div>
                      <div className="news_name_subblock">
                        <p className="news_name">|</p>
                      </div>
                      <div className="news_name_subblock">
                      <p className="news_name">
                        <i>
                          {(() => {
                            try {
                              const dateStr = news?.date;
                              if (!dateStr) return "—"; // fallback when date missing

                              const parsedDate = new Date(dateStr);
                              if (isNaN(parsedDate.getTime())) return "—"; // invalid date fallback

                              const isoDate = parsedDate?.toISOString()?.slice(0, 10);
                              return displayFormattedDate(isoDate, "DD-MM-YYYY", true);
                            } catch (err) {
                              console.error("Date parse error:", err);
                              return "—";
                            }
                          })()}
                        </i>
                      </p>
                      </div>
                    </div>
                    {/* <div className='news_share_block'>
                      <p className='news_share_text'> 
                        <FeatherIcon.Share2 className="fa" />Share</p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
